import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function WaitlistPanel() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/waitlist").then(({ data }) => setRows(data)).catch(() => toast.error("Could not load waitlist"));
  }, []);

  const exportCsv = async () => {
    try {
      const { data } = await api.get("/admin/waitlist/export", { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "afripantry-waitlist.csv";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Export failed");
    }
  };

  return (
    <div className="card-surface p-6" data-testid="admin-waitlist-panel">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-lg font-black" data-testid="waitlist-count">{rows.length} launch sign-up{rows.length === 1 ? "" : "s"}</h2>
        <button onClick={exportCsv} disabled={!rows.length} data-testid="waitlist-export-button"
          className="flex items-center gap-2 h-10 px-4 rounded-full bg-[#2B5329] text-white text-sm font-semibold disabled:opacity-50">
          <DownloadSimple size={16} weight="bold" /> Export CSV
        </button>
      </div>
      <ul className="divide-y divide-[#E5E2D9] text-sm">
        {rows.map((r) => (
          <li key={r.email} className="py-3 flex justify-between" data-testid="waitlist-row">
            <span>{r.email}</span>
            <span className="text-[#5C5C54]">{new Date(r.created_at).toLocaleDateString("en-GB")}</span>
          </li>
        ))}
        {!rows.length && <li className="py-6 text-[#5C5C54]">No sign-ups yet.</li>}
      </ul>
    </div>
  );
}
